import { createContext } from "react";

interface GenericContext {
    value: string;
}

const DEFAULT_INITIAL_VALUE = {
    value: "default",
};

export default createContext<GenericContext>(DEFAULT_INITIAL_VALUE);
